<template>
  <div
    class="page home-page"
    :style="`background-image: url(${platformConfig.loginBgImg});`"
  >
    <div class="page-header">
      <img
        v-if="platformConfig.loginLogo"
        :src="platformConfig.loginLogo"
        class="logo"
        @click="jump"
      />
      <div v-else></div>

      <div class="contact-wrap">
        <div class="top">
          <div class="icon-wrap flex row-center">
            <img src="../assets/images/common/icon-contact.png" alt="" />
          </div>

          <div class="right">
            <div>服务热线</div>
            <div class="important">{{ consumerHotline }}转0</div>
          </div>
        </div>
        <div class="bottom">周一至周五 08:30 - 11:30 14:00 - 17:30</div>
      </div>
    </div>

    <!--登录正文内容-->
    <div class="page-content">
      <div v-if="platformConfig.alias === 'default'" class="slogan">
        <span class="first">专业规范｜阳光高效｜灵活配置</span>
        <span class="second">高效合规的数字化招标采购平台</span>
      </div>
      <div v-if="platformConfig.alias === 'gz'" class="slogan">
        <!--<img src="@/assets/images/gzw/logo.png" alt="" @click="jump" />-->
      </div>

      <transition :name="transitionName" mode="out-in">
        <router-view class="router" />
      </transition>
    </div>

    <!-- 页脚 -->
    <footer-component class="footer-wrap" transparent-bg />
  </div>
</template>

<script>
import FooterComponent from '@/components/LayoutComponent/FooterComponent'
import { mapState, mapGetters } from 'vuex'

export default {
  name: 'Home',

  components: {
    FooterComponent
  },

  data() {
    return {
      transitionName: 'fade-transform'
    }
  },

  computed: {
    ...mapState('system', ['consumerHotline']),
    ...mapGetters('system', ['platformConfig'])
  },

  watch: {
    $route(to, from) {
      // 如果to索引大于from索引,判断为前进状态,反之则为后退状态
      if (to.meta.index > from.meta.index) {
        // 设置动画名称
        this.transitionName = 'fade-transform'
      } else {
        this.transitionName = 'fade-transform-right'
      }
    }
  },

  methods: {
    jump() {
      window.location.href = this.platformConfig.portalUrl
    }
  }
}
</script>

<style lang="scss" scoped>
@media screen and (max-width: 1400px) {
  .slogan,
  .contact-wrap,
  .footer-wrap,
  .logo,
  .page-content {
    zoom: 0.85;
  }

  .page-header {
    padding-top: 20px !important;
  }
}

.home-page {
  height: 100vh;
  min-height: 470px;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center bottom;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
}

.page-header {
  box-sizing: border-box;
  width: 100%;
  padding: 44px 52px 0;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .logo {
    height: 58px;
    cursor: pointer;
  }

  // 联系方式样式
  .contact-wrap {
    color: $white-color;

    .top {
      display: flex;
      align-items: center;

      .icon-wrap {
        width: 40px;
        height: 40px;
        margin-right: 6px;
        border-radius: 4px;
        background-color: $primary-color;

        img {
          width: 30px;
        }
      }
      .right {
        text-align: left;
        font-size: 12px;

        .important {
          font-size: 18px;
          @include text-bold;
        }
      }
    }

    .bottom {
      font-size: 12px;
      margin-top: 4px;
    }
  }
}

.page-content {
  min-width: 960px;
  max-width: 1240px;
  width: 90%;
  display: flex;
  justify-content: space-between;

  .slogan {
    text-align: left;
    padding-top: 50px;
    span {
      color: $white-color;
      letter-spacing: 4px;
      display: block;

      &.first {
        font-size: 38px;
      }
      &.second {
        font-size: 22px;
        margin-top: 24px;
        border-radius: 24px 0px 24px 0px;
        display: inline-block;
        padding: 8px 24px;
        background: $primary-color;
      }
    }

    img {
      width: 648px;
      cursor: pointer;
    }
  }
}
</style>
